<template>
  <SCAInputBase
    :appearance="appearance"
    :inverted="inverted"
    :disabled="disabled"
    :fixed-width="fixedWidth"
    :class="[$style.inputBase, { [$style.inputBaseNavBar]: isNavBarSearch, [$style.shadowed]: showShadow }]"
    :fixed-height="isNavBarSearch"
  >
    <slot />
    <template v-if="showClearIcon" #after>
      <SCASvgIcon
        :class="{
          [$style.clearIcon]: !disabled,
          [$style.borderAppearanceMargin]: appearance === 'border',
          [$style.navBarIconClear]: isNavBarSearch,
        }"
        :disabled="disabled || !showClearIcon"
        :size="'12px'"
        icon="phosphor/x"
        @click="(e: Event) => emit('clear', e)"
      />
    </template>
    <slot name="after" />
  </SCAInputBase>
</template>

<script setup lang="ts">
import SCAInputBase from "./SCAInputBase.vue";
import SCASvgIcon from "./SCASvgIcon.vue";
import type { InputAppearance } from "./types";

const emit = defineEmits<(event: "clear", e: Event) => void>();

withDefaults(
  defineProps<{
    disabled?: boolean;
    appearance?: InputAppearance;
    fixedWidth?: boolean;
    showClearIcon?: boolean;
    isNavBarSearch?: boolean;
    showShadow?: boolean;
    /** For a search sitting on the brand-coloured dialog header. */
    inverted?: boolean;
  }>(),
  {
    disabled: false,
    appearance: undefined,
    fixedWidth: false,
    showClearIcon: true,
    isNavBarSearch: false,
    showShadow: false,
    inverted: false,
  },
);
</script>

<style module lang="scss">
@use "../styles/icon.scss" as IconMixins;

.searchIcon {
  --size: 16px;
  margin-right: var(--space-component-padding-small);
}
.clearIcon {
  @include IconMixins.icon-clickable;
}

.borderAppearanceMargin {
  margin: var(--space-component-padding-small);
}
.inputBase {
  --sca-input-base-gap: 0;
  > div {
    height: var(--dimension-350);
  }
}

.inputBaseNavBar {
  --sca-input-base-gap: var(--space-component-padding-small);
}

.navBarIconSearch {
  --size: 20px;
  margin: var(--space-component-padding-xSmall);
  margin-right: var(--space-component-padding-null);
}

.navBarIconClear {
  margin: 6px var(--space-component-padding-small);
  margin-left: var(--space-component-padding-null);
}

.shadowed {
  border-radius: var(--border-radius-large);
  box-shadow: 0 1px 2px 0 #1b242c1f;
}
</style>
